import type {PermissionsRecordType} from '../permissions';

export const serviceCasePermissions = {
  serviceCaseRead: {
    resourceId: 'SERVICE_CASE',
    actionId: 'READ',
    scopes: [],
  },
  serviceCaseCreate: {
    resourceId: 'SERVICE_CASE',
    actionId: 'CREATE',
    scopes: [],
  },
  serviceOrderCreate: {
    resourceId: 'SERVICE_ORDER',
    actionId: 'CREATE',
    scopes: [],
  },
  serviceOrderEdit: {
    resourceId: 'SERVICE_ORDER',
    actionId: 'EDIT',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE'],
  },
  editPartsListReady: {
    resourceId: 'SERVICE_REQUEST',
    actionId: 'PARTS_LIST_READY_EDIT',
    scopes: [],
  },
  editPartsListRequest: {
    resourceId: 'SERVICE_REQUEST',
    actionId: 'PARTS_LIST_REQUEST_EDIT',
    scopes: [],
  },
  editSolution: {
    resourceId: 'SERVICE_REQUEST',
    actionId: 'SOLUTION_EDIT',
    scopes: [],
  },
  serviceCaseCustomFields: {
    actionId: 'CUSTOM_FIELDS_PAYLOAD_UPDATE',
    resourceId: 'SERVICE_CASE',
    scopes: ['BRANCH', 'PARTICIPATION'],
  },
  serviceOrderCustomDiscountEdit: {
    resourceId: 'SERVICE_ORDER',
    actionId: 'CUSTOM_DISCOUNT_EDIT',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE', 'BRANCH_SPECIFIC'],
  },
  serviceOrderCustomerContractEdit: {
    resourceId: 'SERVICE_ORDER',
    actionId: 'CUSTOMER_CONTRACT_EDIT',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE', 'BRANCH_SPECIFIC'],
  },
  serviceItemLabourCustomPriceEdit: {
    resourceId: 'SERVICE_ITEM',
    actionId: 'LABOUR_CUSTOM_PRICE_EDIT',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE', 'BRANCH_SPECIFIC'],
  },
  serviceItemLabourManualDiscountEdit: {
    resourceId: 'SERVICE_ITEM',
    actionId: 'LABOUR_MANUAL_DISCOUNT_EDIT',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE', 'BRANCH_SPECIFIC'],
  },
  serviceItemMaterialCustomPriceEdit: {
    resourceId: 'SERVICE_ITEM',
    actionId: 'MATERIAL_CUSTOM_PRICE_EDIT',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE', 'BRANCH_SPECIFIC'],
  },
  serviceItemMaterialManualDiscountEdit: {
    resourceId: 'SERVICE_ITEM',
    actionId: 'MATERIAL_MANUAL_DISCOUNT_EDIT',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE', 'BRANCH_SPECIFIC'],
  },
  serviceOrderFinancesProfitabilityRead: {
    resourceId: 'SERVICE_ORDER',
    actionId: 'FINANCES_PROFITABILITY_TAB_READ',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE', 'BRANCH_SPECIFIC'],
  },
  serviceOrderFinancesLabourItemRead: {
    resourceId: 'SERVICE_ORDER',
    actionId: 'FINANCES_LABOUR_ITEM_READ',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE', 'BRANCH_SPECIFIC'],
  },
  serviceOrderFinancesMaterialItemRead: {
    resourceId: 'SERVICE_ORDER',
    actionId: 'FINANCES_MATERIAL_ITEM_READ',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE', 'BRANCH_SPECIFIC'],
  },
} satisfies PermissionsRecordType;
